import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OrgsService } from "@app2/account/orgs.service";
import { PercolatorQuery } from "@app2/classifiers/type-defs";
import { RestClient } from "@app2/clients/rest-client";
import { EnvironmentService } from "@app2/shared/services/environment.service";

const excludeProps = ["applyMetadata", "query", "apply_metadata"];
const percolatorParams = {};

@Injectable({
    providedIn: "root",
})
export class PercolatorClientService {
    private client: RestClient;

    constructor(httpClient: HttpClient,
                envService: EnvironmentService,
                orgsService: OrgsService) {
        const baseUrl = envService.getConfig().searchService;
        this.client = new RestClient(baseUrl, httpClient, orgsService);
    }

    public createQuery(query: PercolatorQuery): Promise<PercolatorQuery> {
        return this.client.doPost("/percolator", query, percolatorParams, excludeProps);
    }

    public getQueries(): Promise<PercolatorQuery[]> {
        return this.client.doGet("/percolators", percolatorParams, excludeProps);
    }

    public updateQuery(query: PercolatorQuery): Promise<PercolatorQuery> {
        return this.client.doPut(`/percolator/${query.id}`, query, percolatorParams, excludeProps);
    }

    public pauseQuery(id): Promise<PercolatorQuery> {
        return this.client.doPost(`/percolator/${id}/pause`, null, percolatorParams, excludeProps);
    }

    public resumeQuery(id): Promise<PercolatorQuery> {
        return this.client.doPost(`/percolator/${id}/resume`, null, percolatorParams, excludeProps);
    }

    public deleteQuery(id): Promise<void> {
        return this.client.doDelete(`/percolator/${id}`);
    }

    public undeleteQuery(id): Promise<void> {
        return this.client.doPost(`/percolator/${id}/undelete`);
    }

    public downloadCsv(): Promise<Blob> {
        return this.client.downloadCsvGet("/percolators");
    }
}
